import * as React from 'react';
import { Route } from 'react-router';
import { Redirect } from 'react-router-dom';
import { USER_STORAGE_USER_KEY } from '../../sagas/login/utils';
import styles from './CustomRoute.module.scss';
//redux
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
//redux states
import { BounceLoader } from 'react-spinners';
import { RootState } from '../../store';
import { LoginState } from '../../store/login/reducer';
import { userSelector } from '../../store/login/selector';
//tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../utils/translations/translator';
interface StateProps {
  user: any;
  loginState: LoginState;
}
interface OwnProps {
  component: any;
  path: string;
  isPublic: boolean;
}

export const CustomRoute: React.FC<
  StateProps & RouteComponentProps & OwnProps
> = ({ component: Component, isPublic, loginState, ...rest }: any) => {
  const { t } = useTranslation();
  const SKIP_LOADING_ROUTES = ['/premium', '/tips'];
  const skipLoadingLocation = SKIP_LOADING_ROUTES.some((substring) =>
    window.location.href.includes(substring),
  );
  if (!skipLoadingLocation && (!loginState.requested || loginState.isLoading)) {
    return (
      <div className={styles.loader}>
        <BounceLoader color={'#6633ff'} size={25} />
        <p>{tr(t, 'loading')} ...</p>
      </div>
    );
  } else
    return (
      <Route
        {...rest}
        render={(props) => {
          const user = localStorage.getItem(USER_STORAGE_USER_KEY);
          
          // Si el usuario está logueado y accede a /login o /signup, redirigir a home
          if (user && isPublic && (props.location.pathname === '/login' || props.location.pathname === '/signup' || props.location.pathname.startsWith('/login/'))) {
            return <Redirect to="/" />;
          }
          
          if (user || isPublic) {
            return <Component {...props} />;
          } else {
            return (
              <Redirect
                exact
                to={{
                  pathname: '/login',
                  state: { from: props.location },
                }}
              />
            );
          }
        }}
      />
    );
};
const mapStateToProps = (state: RootState) => ({
  user: userSelector(state),
  loginState: state.login,
});

export const ConnectedCustomRoute = withRouter(
  connect(mapStateToProps)(CustomRoute),
);
